<div class="container">
  <div class="modalHeader">
    <div class="d-flex justify-content-end mt-1">
      <app-dialog-button></app-dialog-button>
    </div>

    <div class="detalhe-header">
      <span class="detalhe-header-icone">
        <i-lucide [name]="dados.icone" size="22"></i-lucide>
      </span>

      <div>
        <div class="title-modal-mat" id="tituloResumoModulo">{{ dados.titulo }}</div>
        <p class="detalhe-sub">{{ dados.contexto }}</p>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <div class="detalhe-tags">
      <span class="detalhe-tag" [ngClass]="dados.ativo ? 'ativo' : 'inativo'">
        {{ dados.ativo ? 'Ativo' : 'Inativo' }}
      </span>

      <span class="detalhe-tag breve" *ngIf="emBreve">Em breve</span>
    </div>

    <p class="detalhe-descricao">{{ dados.descricao }}</p>

    <dl class="detalhe-dados">
      <div class="detalhe-dado">
        <dt>Situação da tela</dt>
        <dd>{{ emBreve ? 'Em desenvolvimento' : 'Publicada' }}</dd>
      </div>

      <div class="detalhe-dado">
        <dt>Tela</dt>
        <dd>{{ dados.rota || 'Não disponível' }}</dd>
      </div>
    </dl>

    <ng-container *ngIf="recursos.length > 0">
      <h6 class="detalhe-secao">O que você encontra nesta tela</h6>

      <ul class="detalhe-itens">
        <li *ngFor="let recurso of recursos">
          <i-lucide name="check" size="14"></i-lucide>
          {{ recurso }}
        </li>
      </ul>
    </ng-container>

    <p class="detalhe-aviso" *ngIf="emBreve">
      <i-lucide name="info" size="16"></i-lucide>
      Esta tela ainda está em desenvolvimento e será liberada em breve.
    </p>

    <div class="d-flex justify-content-end my-3 gap-2">
      <button type="button" class="btn btn-cancelar-modal" mat-dialog-close title="Fechar detalhes">
        Fechar
      </button>

      <button
        type="button"
        class="btn btn-add"
        *ngIf="!emBreve"
        [title]="rotuloAbrir"
        (click)="abrir()">
        {{ rotuloAbrir }}
      </button>
    </div>
  </div>
</div>
